var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('numerations-manager',{ref:"NumerationsManager"}),_c('show-numerations',{ref:"ShowNumerations"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }